import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { IconButton, makeStyles, Paper, Tooltip } from '@material-ui/core'
import moment from 'moment'
import conferenceSlice, { deleteConferenceAlongData, fetchConference } from 'store/conference'
import ActionBar from 'components/ActionBar'
import ViewHeader from 'components/ViewHeader'
import Wrapper from 'components/Wrapper'
import BasicTable from 'components/BasicTable'
import getTableOptions from 'utils/getTableOptions'
import ResourceNotFound from 'components/ResourceNotFound'
import { EditOutlined, DeleteOutlined } from '@material-ui/icons'
import ConfirmModal from 'components/ConfirmationModal'
import { toast } from 'react-toastify'

const tableHead = ['Conf Name', 'Code', 'Start Date', 'End Date', 'Is Active', 'Actions']
const formatTableData = (conferences) =>
  conferences.map((conference) => [
    conference?.confName,
    conference?.confCode,
    moment(conference?.startDate).tz(conference?.timezone).format('M/D/YYYY'),
    moment(conference?.endDate).tz(conference?.timezone).format('M/D/YYYY'),
    conference?.isActive ? 'Yes' : 'No',
    <ActionButtons conference={conference} />
  ])

const ActionButtons = ({ conference }) => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const location = useLocation()
  const history = useHistory()
  const [deletedId, setDeletedId] = useState('')
  const [loading, setLoading] = useState(false)

  const openModal = (id) => {
    setDeletedId(id)
  }
  const closeModal = () => {
    setDeletedId('')
  }
  const handleEdit = () => {
    history.push(`${location.pathname}/edit/${conference?.id}`)
  }

  const handleDeleteConference = async () => {
    if (deletedId) {
      setLoading(true)
      await dispatch(deleteConferenceAlongData(deletedId))
      toast.success('Conference along with data deleted successfully.')
    }
    setLoading(false)
  }
  return (
    <>
      <ConfirmModal
        dialogTitle="Delete Conference"
        dialogText="This will delete all the data related to this conference, Do you still wish to continue? "
        open={Boolean(deletedId)}
        closeModal={closeModal}
        handleConfirm={handleDeleteConference}
        inProgress={loading}
      />
      <Tooltip title="Edit">
        <IconButton className={classes.iconButton} onClick={handleEdit}>
          <EditOutlined color="action" />
        </IconButton>
      </Tooltip>

      <Tooltip title="Delete">
        <IconButton className={classes.iconButton} onClick={() => openModal(conference?.id)}>
          <DeleteOutlined color="action" />
        </IconButton>
      </Tooltip>
    </>
  )
}

const ConferenceListing = () => {
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()

  const { inProgress, conferences, currentPage, pageSize } = useSelector(
    (state) => state.conference
  )

  useEffect(() => {
    dispatch(fetchConference())
  }, [dispatch])

  const options = getTableOptions()

  return (
    <>
      <ViewHeader title="Conferences">
        <ActionBar
          actionText="New Conference"
          onAction={() => history.push(`${location.pathname}/new`)}
        />
      </ViewHeader>
      <Wrapper inProgress={inProgress}>
        <Paper variant="outlined" style={{ marginTop: '20px' }}>
          {conferences.length ? (
            <BasicTable
              data={formatTableData(conferences)}
              columns={tableHead}
              options={{
                ...options,
                onChangePage: (page) => dispatch(conferenceSlice.actions.setCurrentPage(page)),
                onChangeRowsPerPage: (size) => dispatch(conferenceSlice.actions.setPageSize(size)),
                page: currentPage,
                rowsPerPage: pageSize
              }}
            />
          ) : (
            <ResourceNotFound message="No conference available" />
          )}
        </Paper>
      </Wrapper>
    </>
  )
}

export default ConferenceListing

const useStyles = makeStyles({
  iconButton: {
    padding: '8px'
  }
})
